<template>
  <ob-modal2 :show.sync="show" :backdrop="false">
    <template slot="modal-title">
    {{IsEdit ? "Update" : "Add"}} Emergency Contact
    </template>
    <template slot="modal-body">
      <div class="add_task">
        <div class="row">
          <div class="form-group col-md-6">
            <label>Contact Name</label><span class="validation-star">*</span>
            <ob-input v-formi9-name v-model="conatactName" placeholder="Enter Contact Name" :class="{ 'ob-vuelidate_input-error': $v.conatactName.$error }" @input="updateValue(conatactName)"></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.conatactName.$dirty && !$v.conatactName.required">Please Enter Contact Name</span>
          </div>
          <div class="form-group col-md-6">
            <label>Phone Number</label>
            <ob-input v-model.trim="PhoneNumber" v-phone-number placeholder="Enter Phone Number"  ></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.PhoneNumber.$dirty && !$v.PhoneNumber.maxLength">Please enter valid phone number</span>
            <span class="ob-vuelidate_error-msg" v-if="$v.PhoneNumber.$dirty && !$v.PhoneNumber.minLength">Please enter valid phone number</span>
          </div>
        </div>
          <div class="row">
          <div class="form-group col-md-6">
            <label>Email Address</label>
            <ob-input v-model="Email"  placeholder="Enter Email Address"></ob-input>
             <span class="ob-vuelidate_error-msg" v-if="!$v.Email.email">Please Enter Valid Email</span>
          </div>
          <div class="form-group col-md-6">
            <label>Relationship</label>
            <ob-input v-model="RelationShip" placeholder="Enter Relationship"></ob-input>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <ob-button type="secondary"  @click="cancel()">Cancel</ob-button>
      <ob-button @click="isValid()">{{IsEdit ? "Update" : "Add"}}</ob-button>
    </template>
  </ob-modal2>
</template>
<script>
import namevalidation from "Vue/Core/namevalidation.js"
import { required, minLength, maxLength, email} from 'vuelidate/lib/validators'
const phoneNumber = (value) => {
  var phone = /^[0-9 +()-]+$/i
  return phone.test(value)
}
export default {
  props: ["openModal","IsEdit","PreviousData","EmpId"],
  data() {
    return {
     show: false,
     conatactName:'',
     Email:'',
     PhoneNumber:'',
     RelationShip :'',
     Id:''
    }
  },
  validations() {
    return{
      "conatactName":{
        required
      },
      "Email":{
        email,
      },
      "PhoneNumber":{
      //phoneNumber,
      maxLength: maxLength(20),
      minLength: minLength(10),
      }
    }
  },
  watch:{
    showModal(val){
      this.show = val
      if(val)
      {
        this.resetValues()
        if(this.IsEdit){
        this._previousData()
        }
      }
    },
  },
  created(){
    this.show = this.openModal
  },
  computed:{
    showModal(){
      return this.openModal
    },
  },
  methods:{
    updateValue(value){
      let val = namevalidation.getValidName(value);
      this.conatactName = val
    },
    resetValues(){
      this.conatactName = '';
      this.PhoneNumber ='',
      this.RelationShip ='',
      this.Email = '',
       this.Id ='',
      this.$v.conatactName.$reset();
    },
    _previousData(){
     this.conatactName = this.PreviousData.Name,
     this.PhoneNumber  = this.PreviousData.PhoneNumber,
     this.Email        = this.PreviousData.Email
     this.RelationShip = this.PreviousData.RelationShip
     this.Id           = this.PreviousData.Id
    },
    isValid() {
      this.$v.conatactName.$touch();
      this.$v.Email.$touch();
      this.$v.PhoneNumber.$touch();
       if(this.$v.conatactName.$error == false && this.$v.Email.$error == false && this.$v.PhoneNumber.$error == false){
        this.$loading({
          'loadingText': 'Loading...'
        })

          var Obj =  {
          "Id":this.Id,
          "Name": this.conatactName,
          "Email":this.Email,
          "PhoneNumber":this.PhoneNumber,
          "RelationShip":this.RelationShip
         }
        if(this.IsEdit){
          this.editEmergencyContact(Obj)
        }else{
          this.addEmergencyContact(Obj)
        }

    //    this.Test(Obj)
       this.show = false
       this.$emit('close')
      }
      else{
        this.show = true
      }

    },
     cancel(){
      this.show = false
      this.$emit('close')
    },
    addEmergencyContact(obj){
      ajax.put(`Employee/${this.EmpId}/AddEmergencyContact?loggedInOrgId=${this.loggedInUserObj.orgId}`,obj, (res) => {
        if(res.data.State == true) {
          this.$parent.getEmployeeDatails()
          this.$message({
            type: 'success',
            message: "Emergency Contact Added Successfully"
          });
          //this.$parent.$parent.fetchData('addtask')
          this.$loading({}).close();
        }else if(res.data.State == false){
          this.$loading({}).close();
          this.$message({
              type: 'error',
              message: res.data.Message
          });
        }
      });
    },
    editEmergencyContact(obj){
       ajax.put(`Employee/${this.EmpId}/UpdateEmergencyContact?loggedInOrgId=${this.loggedInUserObj.orgId}`,obj, (res) => {
        if(res.data.State == true) {
          this.$parent.getEmployeeDatails()
          this.$message({
            type: 'success',
            message: "Emergency Contact Updated Successfully"
          });
          this.$loading({}).close();
        }else if(res.data.State == false){
          this.$loading({}).close();
          this.$message({
              type: 'error',
              message: res.data.Message
          });
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ESSProfile/AddEmergencyContact.vue